module.exports = __webpack_public_path__ + "images/logo_full.png?0626a701d9ab96b1b5508ee5b73848b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_full.png
// module id = 15
// module chunks = 0